import { graphql } from '@/utils/graphql';

export type FeedbackReason = 'incorrect' | 'not_followed' | 'bug';

/**
 * What a thumbs-down tells the BEEM team about the answer it is on. The answer itself is never
 * part of it: it carries the customer's data. The connector keeps only these fields.
 */
export type FeedbackContext = {
  question?: string;
  conversationId?: string;
  messageIndex: number;
  tools: string[];
  answerLength: number;
  memoryCount?: number;
  hadReasoning: boolean;
  page: string;
};

/**
 * A thumbs-down on an AI Insights answer (BEEM-1448). The connector files it as a HubSpot ticket
 * on the signed-in user's contact and their organization's company, both resolved on the server.
 */
export default class InsightFeedback {
  // The ticket's id, or null where the environment files no tickets.
  static async report(input: {
    workspaceId: string;
    reason: FeedbackReason;
    note?: string;
    context: FeedbackContext;
  }): Promise<string | null> {
    const rs = await graphql('beemAgentReportInsightFeedback', {
      query: {
        workspaceId: input.workspaceId,
        reason: input.reason,
        ...(input.note ? { note: input.note } : {}),
        context: JSON.stringify(input.context),
      },
    });
    return rs.ticketId ?? null;
  }
}
